import Cache from "csi/store/Cache";
import { C8Node, C8NodeType } from "csi/typings";

export const TYPE_PART_MATERIAL: C8NodeType = "PartMaterial";

export function partMaterialIsSpecial(cache: Cache, partMaterial?: C8Node): boolean {
	return !!cache.get(partMaterial?.Actual)?.Special;
}